import React from "react";
import { Navigate } from "react-router-dom";
import AuthService from "services/auth.service";

const Check = ({ children }) => {
  const currentUser = AuthService.getCurrentUser();
  return currentUser ? children : <Navigate to="/" replace />;
};

export default Check;
